var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHocLieuSoDungChung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#ed1869;}.cls-3{fill:#3d55a5;}.cls-4{fill:#18b575;}.cls-5{fill:#fdbc42;}.cls-6{fill:#fbdeb1;}.cls-7{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "H\\u1ECDc_li\\u1EC7u_s\\u1ED1",
    "data-name": "H\\u1ECDc li\\u1EC7u s\\u1ED1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.15,48.14V150.78a23.67,23.67,0,0,0,7.67,16.92H39.09a8,8,0,0,1-8-8V52a3.86,3.86,0,0,1,3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,65.22H48a23.72,23.72,0,0,0-17,7.67V52.14a4,4,0,0,1,4-4H213.55a5.38,5.38,0,0,1,5.38,5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.85,167.7V65.07a23.67,23.67,0,0,0-7.67-16.93h20.76a4,4,0,0,1,4,4V163.71a4,4,0,0,1-4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.07,150.61H202a23.61,23.61,0,0,0,17-7.67v20.77a4,4,0,0,1-4,4H35.06a4,4,0,0,1-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.15,135.06v15.67a23.77,23.77,0,0,0,7.67,17H35.07a4,4,0,0,1-4-4V138.92a3.86,3.86,0,0,1,3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 82.3,
    y: 189.72,
    width: 85.39,
    height: 12.14,
    rx: 5.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-6",
    d: "M164.11,65.14H131.29a17,17,0,0,1-9.24-2.72A77.22,77.22,0,0,1,113,55.63c-1.65-1.51-3.31-3-5.55-3H96.09a6.63,6.63,0,0,0-6.62,6.63V71.74h69.05a5.64,5.64,0,0,1,5.64,5.63v54.95a6.62,6.62,0,0,0,6.57-6.62V71.77A6.62,6.62,0,0,0,164.11,65.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-5",
    x: 83.83,
    y: 70.98,
    width: 80.59,
    height: 67.61,
    rx: 6.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M144.78,90.11a1.75,1.75,0,0,1-1.64,1.83H96.89a1.84,1.84,0,0,1,0-3.66h46.25A1.74,1.74,0,0,1,144.78,90.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.49,101.93H97.09a1.83,1.83,0,1,1,0-3.66h26.4a1.83,1.83,0,0,1,0,3.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 97.54,
    cy: 77.66,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 106.26,
    cy: 77.66,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 114.98,
    cy: 77.66,
    r: 2.28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHocLieuSoDungChung);
export default __webpack_public_path__ + "static/media/hoc_lieu_so_dung_chung.51afdb9bd716d2da2edc4774ed5ccec3.svg";
export { ForwardRef as ReactComponent };